// Stagger reveal — cards animate in one by one as they scroll into view

const items = document.querySelectorAll('.features-grid__item');

if (items.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            });
        },
        { threshold: 0.12 }
    );

    items.forEach((item, i) => {
        // Stagger delay: 0ms, 80ms, 160ms …
        item.style.transitionDelay = `${i * 80}ms`;
        observer.observe(item);
    });
}
